import ContactConfirmation from './ContactConfirmation';

export default ContactConfirmation;
